<span
  class="ui-tooltip"
  (mouseenter)="show()"
  (mouseleave)="hide()"
  tabindex="0"
  [attr.aria-label]="text()"
>
  <ng-content />
  @if (visible()) {
    <span class="ui-tooltip__bubble ui-tooltip__bubble--{{ position() }}" role="tooltip">
      {{ text() }}
    </span>
  }
</span>
